// src/theme.ts
import { createTheme, DEFAULT_THEME, MantineColorsTuple, rem } from '@mantine/core';

const myColor: MantineColorsTuple = [
  '#e6f5ff',
  '#d2e6fe',
  '#a7c9f4',
  '#78abeb',
  '#5191e3',
  '#3881df',
  '#2879de',
  '#1767c6',
  '#085cb2',
  '#004f9f',
]

const baseTheme = {
  autoContrast: true,
  fontFamily: `Open Sans, ${DEFAULT_THEME.fontFamily} sans-serif`,
  headings: {
    fontFamily: `Open Sans, ${DEFAULT_THEME.fontFamily}`,
    // fontWeight: '700',
    sizes: {
      h1: {
        // fontWeight: '700',
        fontSize: rem(22),
        // lineHeight: '1.6',
      },
      h2: {
        // fontWeight: '700',
        fontSize: rem(18),
        // lineHeight: '1.4',
      },
      h3: {
        // fontWeight: '600',
        fontSize: rem(16),
        // lineHeight: '1.2',
      },
      h4: {
        // fontWeight: '700',
        fontSize: rem(14),
        // lineHeight: '1.4',
      },
      h5: {
        // fontWeight: '700',
        fontSize: rem(12),
        // lineHeight: '1.4',
      },
      h6: {
        // fontWeight: '700',
        // fontSize: rem(24),
        // lineHeight: '1.4',
      },
    },
  },
  fontSizes: {
    xs: rem(10),
    sm: rem(12),
    md: rem(13),
    lg: rem(15),
    xl: rem(18),
  },
  // lineHeights: {
  //   xs: '1.4',
  //   sm: '1.45',
  //   md: '1.5',
  //   lg: '1.6',
  //   xl: '1.65',
  // },
  colors: {
    myColor,
  },
}
export const theme = createTheme({
...baseTheme
});